export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEINzgtRVVDLUhhBaGiAb1PDQG9UQkCvVMCBL1WBBG9W0EVoeG9bYU/AAEAAQABAAEAGQAfAAEAAQAGAIEyAAEAAQABAAEAGQAfAAEAAQAGAGEBpfUBvgI=", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/78-EUC-V.bcmap
// module id = 568
// module chunks = 502